import { Component, OnInit,ElementRef, AfterViewInit, ViewChild } from '@angular/core';
import { Http, Headers, Response,RequestOptions} from '@angular/http';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map'
import { AlertService,UserService } from '../_services/index';
declare let $: any;
declare let Ladda:any
import { DatePipe } from '@angular/common';
import { NgForm } from '@angular/forms';
import { environment } from '../../environments/environment';
import { Router, ActivatedRoute,Params} from '@angular/router';
import {} from '@types/googlemaps';
import { Helper } from '../_helpers/index';
declare var google;
@Component({
  selector: 'app-address',
  templateUrl: './address.component.html',
  styleUrls: ['./address.component.css'],
})

export class AddressComponent{
data:any;
  backendUrl:any;
  sel_id:any;
  loadingnew = false;
  loading = false;
  complexForm:FormGroup;
  model: any = {};
  markersArray: any = {};
  id:number;
  autocomplete:any;
  map:any;
  geocoder:any;
  time_zone:any;

constructor(fb: FormBuilder,private http: Http,private datePipe: DatePipe,private userService:UserService,private router: Router,private activatedRoute: ActivatedRoute,private helper: Helper) {
    this.complexForm = fb.group({
      // To add a validator, we must first convert the string value into an array. The first item in the array is the default value if any, then the next item in the array is the validator. Here we are adding a required validator meaning that the firstName attribute must have a value in it.

      // We can use more than one validator per field. If we want to use more than one validator we have to wrap our array of validators with a Validators.compose function. Here we are using a required, minimum length and maximum length validator.

    })

  }
  ngOnInit(){

  let url=window.location.hostname;
    // if(url=='app.foodbot.ai' || url=='dashboard.foodbot.ai'){this.backendUrl=environment.prod}
    // else if(url=='stage.foodbot.ai'){ this.backendUrl=environment.stage}
    // else if(url=='uat.foodbot.ai'){ this.backendUrl=environment.uat}
    // else{ this.backendUrl=environment.local}
    if (url == 'app.foodbot.ai' || url == 'dashboard.foodbot.ai') { this.backendUrl = environment.prod } else if (url == 'stage.foodbot.ai') { this.backendUrl = environment.stage } 
    else if (url == 'uat.foodbot.ai') { this.backendUrl = environment.uat } 
    else if (url == '127.0.0.1') { this.backendUrl = environment.local } 
    else { 
      this.backendUrl=window.location.origin
      this.backendUrl+="/apis"
    }

    let currentUser = JSON.parse(localStorage.getItem('currentUser'));
     let restaurant_id=currentUser.restaurant_id;
     this.time_zone = currentUser.time_zone ? currentUser.time_zone : 'America/Mexico_City';
     let sql="SELECT * FROM fb_branches where restaurant_id="+restaurant_id+" order by branch_id asc" 
     let headers = new Headers ({  'Content-Type': 'application/json' });
     let options = new RequestOptions({ headers: headers, method: "post" });

      this.userService.getdata(this.backendUrl,JSON.stringify({'query': sql}))
            .subscribe(data => {
            if(data.length > 0) {
              this.id = data[0].branch_id;
              let address1 = data[0].address1;
              let address2 = data[0].address2;
              let address3 = data[0].locality;
              this.model.address = address1;
              console.log(this.model.address);

              this.model.city = data[0].city;
              this.model.state = data[0].state;
              this.model.country = data[0].country;
              this.model.latitude = data[0].latitude;
              this.model.longitude = data[0].longitude;
              console.log(data[0].longitude);
            }
        });


function getLocation() {
    if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(showPosition);
    } else { 
        //x.innerHTML = "Geolocation is not supported by this browser.";
    }
}
function showPosition(position) {
  //alert( "Latitude: " + position.coords.latitude + "<br>Longitude: " + position.coords.longitude);
  (<HTMLInputElement>document.getElementById("latt")).value = position.coords.latitude;
  (<HTMLInputElement>document.getElementById("longe")).value = position.coords.longitude;
}


$(document).ready(function(){

$.validator.addMethod("clsRequired", function(value, element) { 
  return value == '' || value.trim().length != 0; 
}, "This Field is required");

$.validator.addMethod("alphanum", function(value, element){
    if (/^[a-zA-Z0-9\-\s]+$/.test(value)) {
        return true;  // FAIL validation when REGEX matches
    } else {
        return false;   // PASS validation otherwise
    };
}, "Alphanumeric and spaces only allowed");

$("input").on("keypress", function(e) {
    if (e.which === 32 && !this.value.length)
        e.preventDefault();
});
	
	$('#addbranch').validate({
        rules:{
          address:{required:true},
          city:{required:true,minlength:3},
          state:{required:true,minlength:3},
          country:{required:true,minlength:3},

        },
        messages:{
          address:{required:"This Field is required"},
          city:{required:"This Field is required",minlength:"City name minimum of 3 Characters"},
          state:{required:"This Field is required",minlength:"State name minimum of 3 Characters"},
          country:{required:"This Field is required",minlength:"country name minimum of 3 Characters"},

        },
        errorPlacement: function(error, element) {
          if (element.type == 'checkbox') {
            error.appendTo(element.parent());
          }
          else {
            error.insertAfter(element);
          }
        }

      })


      var placeSearch, autocomplete;
      var componentForm = { 
      country: 'long_name',
      administrative_area_level_1: 'long_name',
      locality: 'long_name',
      postal_code: 'short_name'  
    };

    function fillInAddress(ac) {
  var place = ac.getPlace();
  console.log(place);
  for (var component in componentForm) {
    (<HTMLInputElement>document.getElementById(component)).value = '';
    (<HTMLInputElement>document.getElementById(component)).disabled = false;
  }
  // Get each component of the address from the place details
  // and fill the corresponding field on the form.
  for (var i = 0; i < place.address_components.length; i++) {
    var addressType = place.address_components[i].types[0]; 
  
    if (componentForm[addressType]) { 
      var val = place.address_components[i][componentForm[addressType]];    
      (<HTMLInputElement>document.getElementById(addressType)).value = val;
      console.log((<HTMLInputElement>document.getElementById(addressType)).value);
    }
  }
    loadMap_custom();
}

      function initAutocomplete() {
    // Create the autocomplete object, restricting the search to geographical
    // location types.
    autocomplete = new google.maps.places.Autocomplete(
        (<HTMLInputElement>document.getElementById('autocomplete')),
        {types: ['geocode']});

    // When the user selects an address from the dropdown, populate the address
    // fields in the form.
    autocomplete.addListener('place_changed', function(){
      fillInAddress(autocomplete);
    });
    
  }

   // [START region_fillform]
 
// [END region_fillform]

       function geolocate() {
  
  if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(function(position) {
      var geolocation = {
       
        lat: position.coords.latitude,
        lng: position.coords.longitude
      };
    
   
  
   
      var circle = new google.maps.Circle({
        center: geolocation,
        radius: position.coords.accuracy
      });
      autocomplete.setBounds(circle.getBounds());
    });
  }
       
}
      var map;
      var home;
      var markersArray = [];      

      function initialize() {
     // '12.9833','77.5833'
     var latInsal = $('#latt').val();
     var longInsal = $('#longe').val();
    var lat2 =   latInsal?latInsal:"";
    var longi2 =   longInsal?longInsal:"";
            home = new google.maps.LatLng(lat2,longi2);   
           var opts = {
                zoom:18,
                center: home,
                mapTypeId: google.maps.MapTypeId.ROADMAP
           };
      
           map = new google.maps.Map(document.getElementById('map_canvas'), opts);
         //showMarker(home);
         
       deleteOverlays(); 
             var marker = new google.maps.Marker({
              position: home,
              map: map,
              draggable: true
              });
          markersArray.push(marker);
          
                google.maps.event.addListener(marker, 'dragend', function() {
                                                 var geocoder = new google.maps.Geocoder();
                        var latitude = this.position.lat();
                        var longitude = this.position.lng();
                        var latLng = new google.maps.LatLng(latitude,longitude);
                        geocoder.geocode({       
                            latLng: latLng     
                            }, 
                            function(responses) {     
                               if (responses && responses.length >0){ 
                                (<HTMLInputElement>document.getElementById("autocomplete")).value = responses[0].formatted_address;
                                var locItemCount = responses[0].address_components.length;
                                var city = responses[0].address_components[locItemCount -4].long_name;
                                var state = responses[0].address_components[locItemCount -3].long_name;                           
                                (<HTMLInputElement>document.getElementById("locality")).value = '';
                                (<HTMLInputElement>document.getElementById("locality")).value = city;
                                
                                (<HTMLInputElement>document.getElementById("administrative_area_level_1")).value = '';
                                (<HTMLInputElement>document.getElementById("administrative_area_level_1")).value = state;
                                
                               }else {       
                               alert('Not getting Any address for given latitude and longitude.');     
                               }   
                            }
                        );                          
                    });       

      }
     
    
 var geocoder = new google.maps.Geocoder();            
  
 function geocodePosition(pos,geocoder) { 
        geocoder.geocode({
        latLng: pos
        }, function(responses){
        if (responses && responses.length > 0) {
          
          document.getElementById('autocomplete').innerHTML = responses[0].formatted_address;
         
        } else {
          
          document.getElementById('autocomplete').innerHTML = 'Cannot determine address at this location.';
        }
        });
} 



      function loadMap(lat,lng)
           { 
               var location= new google.maps.LatLng(lat, lng);
               this.map.setCenter(location);
               document.getElementById("lat").innerHTML = location.lat();
               document.getElementById("lng").innerHTML = location.lng();        
           }

        function showMarker(location) {
          if(location.lat() !=''){
               deleteOverlays();               
               var marker = new google.maps.Marker({
                   position: location,
                   map: map,
           draggable: true,
               });
               markersArray.push(marker);
              
            }     
   }
   function deleteOverlays() {
            if (markersArray) {
                for (var i=0; i < markersArray.length; i++) {
                    markersArray[i].setMap(null);
                }
            markersArray.length = 0;
            }
        }

    
  function loadMap_custom(){
      var geocoder = new google.maps.Geocoder();
            var address = (<HTMLInputElement>document.getElementById('autocomplete')).value ;              
               geocoder.geocode( { 'address': address}, function(results, status) {               
        if (status == google.maps.GeocoderStatus.OK) {       
          var latitude = results[0].geometry.location.lat();
                      var longitude = results[0].geometry.location.lng();
                      $('#latt').val(latitude);
                      $('#longe').val(longitude);
                var location= new google.maps.LatLng(latitude, longitude);
                map.setCenter(location);
                showMarker(location);
                deleteOverlays(); 
                   var marker = new google.maps.Marker({
                          position: location,
                          map: map,
                          draggable: true
                    });
                    markersArray.push(marker);
                    google.maps.event.addListener(marker, 'dragend', function() {
                            var geocoder = new google.maps.Geocoder();
                          var latitude = this.position.lat();
                          var longitude = this.position.lng();
                          var latLng = new google.maps.LatLng(latitude,longitude);
                          geocoder.geocode({       
                              latLng: latLng     
                              }, 
                              function(responses) {     
                                 if (responses && responses.length >0){ 
                                                                  (<HTMLInputElement>document.getElementById("autocomplete")).value = responses[0].formatted_address;
                                  var locItemCount = responses[0].address_components.length;
                                  var city = responses[0].address_components[locItemCount -4].long_name;
                                                                  var state = responses[0].address_components[locItemCount -3].long_name;                           
                                    (<HTMLInputElement>document.getElementById("locality")).value = '';
                                    (<HTMLInputElement>document.getElementById("locality")).value = city;
                                  
                                  (<HTMLInputElement>document.getElementById("administrative_area_level_1")).value = '';
                                    (<HTMLInputElement>document.getElementById("administrative_area_level_1")).value = state;
                                  
                                 }else {       
                                 alert('Not getting Any address for given latitude and longitude.');     
                                 }   
                              }
                          );
                    });       
                  
          } 
            });
        
        
        
    }

      $('#autocomplete').focus(function(){                     
      geolocate();
      initAutocomplete();
       $('.pac-container').css('z-index','9999');
      });
      initAutocomplete();
      setTimeout(function(){
      initialize();
      },600);
      

   }); 




}

  savebranch()
  {
    let dayData = '';
    let date=new Date();
    let date_time=moment(date).format("YYYY-MM-DD HH:mm:ss");
    let currentUser = JSON.parse(localStorage.getItem('currentUser'));
    let restaurant_id=currentUser.restaurant_id;
    var completeAdd = $('#autocomplete').val();
    var addArr = completeAdd.split(",");
    let latti = $('#latt').val();
    let longitu = $('#longe').val();
    let timeZ = '';
    var url = 'https://maps.googleapis.com/maps/api/timezone/json?location='+latti+','+longitu+'&timestamp=1331766000&key=AIzaSyBvCZc5U_bH_qVHJU2xTPfjMrpgQNa8jjQ';
    fetch(url)
          .then((resp) => resp.json())
          .then(function(data1) {
          timeZ = data1.timeZoneId;
          console.log(timeZ);
          });
    setTimeout(()=>{
    if($('#addbranch').valid())
    {
      var l = Ladda.create(document.querySelector('#savebtn'));
      l.start();

      if(this.id){
        let userdata = {
        restaurant_id:restaurant_id,
        address1 : completeAdd,
        address2 : null,
        locality : addArr[2],
        city : $('#locality').val(),
        state : $('#administrative_area_level_1').val(),
        country : $('#country').val(),
        latitude: latti,
        longitude: longitu,
        timezone: timeZ,
        zipcode: $('#postal_code').val(),
        status : 1,
        updated_at : this.helper.getDateTimeInClientTz(date_time,this.time_zone)
      };
        let sql="update fb_branches set ? where branch_id="+this.id;
        this.userService.insert(this.backendUrl,JSON.stringify({'query': sql,'data':userdata}))
          .subscribe(data => {
            l.stop();
            this.ngOnInit();
                $('#success').html('Branch address updated successfully');
                   $('#success').show();
                   setTimeout(function(){
                           $('#success').hide();
                    },3000);
          });
      }
      else{
        let userdata = {
        restaurant_id:restaurant_id,
        address1 : completeAdd,
        address2 : null,
        locality : addArr[2],
        city : $('#locality').val(),
        state : $('#administrative_area_level_1').val(),
        country : $('#country').val(),
        latitude: latti,
        longitude: longitu,
        timezone: timeZ,
        zipcode: $('#postal_code').val(),
        status : 1,
        created_at : this.helper.getDateTimeInClientTz(date_time,this.time_zone),
      };
        let sql="insert into fb_branches SET ?"
        this.userService.insert(this.backendUrl,({'query': sql,'data':userdata}))
          .subscribe(data => {
            this.id = data.id;
            l.stop();
            this.ngOnInit();
                $('#success').html('Branch address saved successfully');
                   $('#success').show();
                   setTimeout(function(){
                           $('#success').hide();
                    },3000);
          });
      }
    }
},1000)
  }
}



// WEBPACK FOOTER //
// /var/www/html/foodbot_stage/web/src/app/address/address.component.ts